import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from 'react-select';

import classNames from 'classnames';

import DefaultTheme from './default-theme';

import './style.css';

export const findOptionsByValue = (options, value, isArray) => {
  if (isArray && Array.isArray(value)) {
    return options.filter((option) => value.includes(option.value));
  }
  return options.find((opt) => opt.value === value);
};

const Select = ({ options, value, isMulti, className, size, ...rest }) => {
  const customClassName = classNames(
    'select-container',
    className,
    `-${size}`,
    {}
  );
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };

  return (
    <BaseSelect
      {...rest}
      classNamePrefix="react-select"
      className={customClassName}
      theme={(theme) => DefaultTheme(theme, size)}
      styles={styles}
      isMulti={isMulti}
      value={findOptionsByValue(options, value, isMulti)}
      options={options}
    />
  );
};

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  isMulti: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number),
  ]),
  className: PropTypes.string,
  size: PropTypes.oneOf(['s', 'm', 'l']),
};

Select.defaultProps = {
  options: [],
  className: null,
  isMulti: false,
  value: null,
  size: 'm',
};

export default Select;
